(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyAdminHomeController', CompanyAdminHomeController);

    CompanyAdminHomeController.$inject = [];

    function CompanyAdminHomeController () {
        var vm = this;        
    }
})();
